import { useEffect, useState } from 'react';
import { useRoutes } from 'react-router-dom';
import { authRoutes, router } from 'src/router';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import SideBarWrapper from './components/sidebarWrapper';
import { ToastContainer, toast } from 'react-toastify';

import useAuth from 'src/hooks/useAuth';
import { CssBaseline } from '@mui/material';
import ThemeProvider from './theme/ThemeProvider';
import AppInit from './components/AppInit';
import internationalization from 'src/i18n/i18n';
import { Elements } from '@stripe/react-stripe-js';

import ErrorBoundary from './wrappers/ErrorBoundary';
import { Provider } from 'mobx-react';
import { Stores } from './stores';
import { StoresProvider } from './providers/store.provider';
import ConditionalWrapper from './components/ConditionalWrapper';
import './index.css';
import LoginJWT from './pages/Auth/Login/LoginJWT';
import RegisterJWT from './pages/Auth/Register/RegisterJWT';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  const [rootStore, setRootStore] = useState<Stores | null>(null);
  const content = useRoutes(router);

  const authContent = useRoutes(authRoutes);
  const auth = useAuth();

  useEffect(() => {
    // auth.logout();
    internationalization.init();
  }, []);

  return (
    <>
      {/*    <ThemeProvider>*/}
      {/* TODO: Move stripe to subscription screen and import it from env file */}
      <StoresProvider getRootStore={(store) => setRootStore(store)}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <ToastContainer
            position="top-right"
            autoClose={2000}
            hideProgressBar={false}
            newestOnTop={false}
            draggable={false}
            closeOnClick
            pauseOnHover
          />
          {/* <ErrorBoundary> */}
          {/* <CssBaseline/> */}
          {auth.user ? <SideBarWrapper>{content}</SideBarWrapper> : authContent}

          {/* </ErrorBoundary> */}
        </LocalizationProvider>
      </StoresProvider>
      {/*   </ThemeProvider>*/}
    </>
  );
}
export default App;
